import React from 'react';
import { useAuth } from '../context/AuthContext';
import { getImageUrl } from '../config';

const GuestProfileBar: React.FC = () => {
    const { user, openProfileModal } = useAuth();

    if (!user) return null;

    const userName = user.name || 'Guest';
    const familySide = user.familySide
        ? `${user.familySide.charAt(0).toUpperCase() + user.familySide.slice(1)}'s Side`
        : 'Wedding Guest';

    return (
        <div className="guest-profile-bar">
            <div 
                className="guest-profile-bar-avatar clickable" 
                onClick={openProfileModal}
                title="Click to view full profile"
                role="button"
                tabIndex={0}
            >
                {user.profilePhoto ? (
                    <img
                        src={getImageUrl(user.profilePhoto)}
                        alt={userName}
                        key={user.profilePhoto}
                    />
                ) : (
                    <span className="guest-profile-bar-initials">{userName.charAt(0)}</span>
                )}
            </div>
            <div className="guest-profile-bar-info">
                <div className="guest-profile-bar-top">
                    <span 
                        className="guest-profile-bar-name clickable"
                        onClick={openProfileModal}
                        title="Click to view full profile"
                        role="button"
                        tabIndex={0}
                    >
                        {userName}
                    </span>
                    <div className="guest-profile-bar-badge">🎉 Guest</div>
                </div>
                <span className="guest-profile-bar-sub">{familySide}</span>

                {/* Info chips — only rendered when data is available */}
                {(user.roomNumber || user.giftCode || user.dietaryInfo || user.location) && (
                    <div className="guest-profile-chips">
                        {user.roomNumber && (
                            <span className="guest-chip">
                                <span className="guest-chip-icon">🛏</span>
                                Room {user.roomNumber}
                            </span>
                        )}
                        {user.giftCode && (
                            <span className="guest-chip">
                                <span className="guest-chip-icon">🎟</span>
                                Token: {user.giftCode}
                            </span>
                        )}
                        {user.dietaryInfo && (
                            <span className="guest-chip">
                                <span className="guest-chip-icon">🍽</span>
                                {user.dietaryInfo}
                            </span>
                        )}
                        {user.location && (
                            <span className="guest-chip">
                                <span className="guest-chip-icon">📍</span>
                                {user.location}
                            </span>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default GuestProfileBar;
